import React, { useState, useEffect } from 'react';
import Table from '../ogComponent/table';
import Spinner from '../ogComponent/spinner';
import axios from 'axios';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Select, MenuItem } from '@mui/material';
import "./attendence.css";

export default function EarlyLate() {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('1'); // 1 = Late-in, 2 = Early-out, 3 = Overtime
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [currentPage, setCurrentPage] = useState(1);

  const header = [
    { name: 'Si No', label: '#', active: true },
    { name: 'employee_code', label: 'Emp ID', active: true },
    { name: 'name', label: 'Employee Name', active: true },
    { name: 'Type', label: 'Category', active: true },
    { name: 'Date', label: 'Date', active: true },
    { name: 'Clock-In', label: 'Check-In', active: true },
    { name: 'Clock-Out', label: 'Check-Out', active: true },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = '';
      if (filter === '1') {
        apiUrl = `${process.env.REACT_APP_API}/api/attendance/late_in/?start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
      } else if (filter === '2') {
        apiUrl = `${process.env.REACT_APP_API}/api/attendance/early_out/?start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
      } else if (filter === '3') {
        apiUrl = `${process.env.REACT_APP_API}/api/attendance/overtime/?start_date=${startDate.format('YYYY-MM-DD')}&end_date=${endDate.format('YYYY-MM-DD')}`;
      }

      const response = await axios.get(apiUrl);
      const formattedData = response.data.map((item, index) => ({
        'Si No': index + 1,
        employee_code: item.employee?.employee_code || 'N/A',
        name: (
          <div className="d-flex align-items-center gap-3">
            <img
              src={item.employee?.profile_photo || '/assets/user.png'}
              className="att-cell-img"
              alt="user"
            />
            <span className="att-name-text">{item.employee?.name || 'N/A'}</span>
          </div>
        ),
        Type: (
          <span className={`badge border-0 ${filter === '1' ? 'bg-danger bg-opacity-10 text-danger' : filter === '2' ? 'bg-warning bg-opacity-10 text-orange' : 'bg-primary bg-opacity-10 text-primary'}`}>
            {filter === '1' ? 'Late-In' : filter === '2' ? 'Early-Out' : 'Overtime'}
          </span>
        ),
        Date: dayjs(item.date).format('DD MMM YYYY'),
        'Clock-In': <span className="fw-bold">{item.clock_in || '--:--'}</span>,
        'Clock-Out': <span className="fw-bold">{item.clock_out || '--:--'}</span>
      }));
      setProduct(formattedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filter, startDate, endDate]);

  return (
    <div className="AttendanceContainer w-100 h-100 px-4 pt-4 pb-5">
      <div className="attendance-header mb-4">
        <h3 className="m-0">Exception Logs</h3>
        <p className="text-muted small mb-0">Review punctuality trends, late entries, and early departures across the team.</p>
      </div>

      <div className="attendance-filters">
        <div className="d-flex gap-2">
          <Select
            className="border-0 shadow-sm"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            sx={{
              height: '40px',
              minWidth: '160px',
              bgcolor: 'var(--bg-color)',
              fontWeight: '600',
              '& fieldset': { border: 'none' }
            }}
          >
            <MenuItem value="1">Late-In Logs</MenuItem>
            <MenuItem value="2">Early-Out Logs</MenuItem>
            <MenuItem value="3">Overtime Logs</MenuItem>
          </Select>
        </div>

        <div className="date-picker-group">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              slotProps={{ textField: { size: 'small', sx: { width: 180 } } }}
            />
            <DatePicker
              label="To"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              slotProps={{ textField: { size: 'small', sx: { width: 180 } } }}
            />
          </LocalizationProvider>
        </div>
      </div>

      {loading ? (
        <div className="py-5 text-center"><Spinner /></div>
      ) : (
        <div className="attendance-table-wrapper">
          {product.length === 0 ? (
            <div className="empty-attendance py-5">
              <img src="/assets/file.png" className="empty-img" alt="No data" />
              <p className="fw-semibold text-muted">No exceptions found for the selected criteria.</p>
            </div>
          ) : (
            <Table
              header={header}
              product={product}
              onRowClick={() => { }}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      )}
    </div>
  );
}
